/** Common ticket type labels shown in the event create/edit dropdown. */
export const PREDEFINED_TICKET_TYPES = [
  "VIP",
  "VVIP",
  "Regular Entry",
  "Stag Entry",
  "Couple Entry",
  "GA",
  "Fanpit",
  "Early Bird VIP",
];

/**
 * Suggested passesPerUnit when admin picks a ticket type name (admin may override).
 * @returns {number|null} preset or null when no rule matches
 */
export function getAutoPassesPerUnit(ticketTypeName) {
  const normalized = String(ticketTypeName || "").trim().toLowerCase();
  if (!normalized) return null;

  if (/couple/.test(normalized)) return 2;
  if (/group\s+of\s+(four|4)/.test(normalized)) return 4;

  if (
    /\bregular\b/.test(normalized) ||
    /\bga\b/.test(normalized) ||
    /\bvip\b/.test(normalized) ||
    /\bvvip\b/.test(normalized)
  ) {
    return 1;
  }

  return null;
}

/** react-select options; merges predefined labels with any saved/custom values. */
export function buildTicketTypeOptions(extraValues = []) {
  const seen = new Set();
  const options = [];

  [...PREDEFINED_TICKET_TYPES, ...extraValues].forEach((label) => {
    const trimmed = String(label || "").trim();
    if (!trimmed) return;
    const key = trimmed.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    options.push({ value: trimmed, label: trimmed });
  });

  return options;
}
